import React from 'react';
import { Route } from 'react-router-dom';
import CancellationPolicy from './CancellationPolicy';

const routes = [
  <Route key="CancellationPolicy" path="/cancellation-policy"><CancellationPolicy/></Route>
];

export default routes;
